import { render, staticRenderFns } from "./check-order-table.vue?vue&type=template&id=a8f04a54&"
import script from "./check-order-table.vue?vue&type=script&lang=js&"
export * from "./check-order-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports